// Chỗ màn làm việc ghi tên bạn sale (QĐ 0485, CEO 26a + 2a; sửa 31/10/2026 — 1a đảo · 3a · 4b): đơn mà
// người nhận cọc là sales của một tiểu đội hiện «logo + TÊN TIỂU ĐỘI» to ở dòng trên, dòng cuối nhỏ ghi
// tiểu đội trưởng · đội · đội trưởng. Người trong Phòng KD / Kế toán / Ban giám đốc thấy thêm tên bạn sale
// nhỏ ở dòng giữa; người ngoài KHÔNG thấy tên bạn sale. Máy chủ quyết ai thấy tên (`showSellerName`) và
// đơn nào có tiểu đội (đơn cũ mang tiểu đội hiện tại của bạn sale). Mọi trường hợp còn lại (người bán
// ngoài cơ cấu, lỗi mạng) giữ nguyên tên bạn sale — `children` là chỗ ghi tên như hôm nay.
// Chỉ đổi cách HIỆN: tên bạn sale vẫn nằm trong dữ liệu đơn. Màn khách KHÔNG dùng linh kiện này.

import type { CSSProperties, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useAuthV2 as useAuth } from "@/lib/authv2/store";
import { useOrderSquadBadge } from "./api";
import { squadLeadLine } from "./format";
import { isSquadInsider } from "./permissions";
import { SquadLogo } from "./SquadLogo";

type Props = {
  /** Mã đơn (uuid). Vắng ⇒ giữ tên bạn sale. */
  orderId: string | null | undefined;
  /** Tên bạn sale như màn đang ghi. */
  children: ReactNode;
  /** Cỡ logo (px). */
  size?: number;
  className?: string;
};

export function SaleOrSquad({ orderId, children, size = 20, className }: Props) {
  const me = useAuth((s) => s.currentStaff);
  // Chưa nạp xong hồ sơ người xem (phiên đang dựng) ⇒ giữ tên, không hỏi máy chủ.
  const q = useOrderSquadBadge(orderId, !!me);
  if (!me || !orderId) return <>{children}</>;
  if (q.isPending && q.fetchStatus !== "idle") {
    // Người trong vốn thấy tên ⇒ hiện tên trong lúc chờ. Người ngoài: khung chờ cùng cỡ, ô không
    // nháy tên bạn sale rồi mới đổi sang tiểu đội.
    if (isSquadInsider(me)) return <>{children}</>;
    return (
      <span
        className={cn("td-cho", className)}
        style={{ width: size * 5, height: size }}
        aria-busy="true"
        aria-label="Đang tải người bán"
      />
    );
  }
  const badge = q.data?.badge ?? null;
  if (!badge) return <>{children}</>;
  const leadLine = squadLeadLine(badge);
  return (
    <span
      className={cn("td-nguoi-ban", className)}
      style={{ "--td-logo": `${size}px` } as CSSProperties}
      data-testid="nhan-tieu-doi"
    >
      <span className="td-nguoi-ban-dong">
        <SquadLogo squad={badge} size={size} mode="ring" />
        <span className="td-nguoi-ban-ten">{badge.name}</span>
      </span>
      {q.data?.showSellerName ? (
        <span className="td-nguoi-ban-sale" data-testid="nhan-tieu-doi-sale">
          {children}
        </span>
      ) : null}
      {leadLine ? <span className="td-nguoi-ban-tdt">{leadLine}</span> : null}
    </span>
  );
}
